(ns ballot-scout-v2-frontend.voter-lookup.common)

(def ns-key :voter-lookup)

(defn get-cached-args
  [db]
  (get-in db [ns-key :args]))

(def default-search-state
  {:page 1
   :sort-by "voter.fullname"})
